import { useRouter } from "next/router";

const usePinned = () => {
  const { asPath } = useRouter();

  return { isPinned: asPath?.includes("/pinned") || false };
};

export default usePinned;
